import { FieldErrors, UseFormRegister } from "react-hook-form";
import { InputCreateEmpresaForm } from "./InputCreateEmpresaForm";
import { SelectCreateEmpresaForm } from "./SelectCreateEmpresaForm";
import { CreateEmpresa } from "../../../types/empresa";
import { EmpresaFiltersData } from "../../../types/filter";

interface Props {
    register: UseFormRegister<CreateEmpresa>;
    errors: FieldErrors<CreateEmpresa>;
    selectValues: EmpresaFiltersData;
}

export function DomicilioSection({ register, errors, selectValues }: Props) {

    return (
            <div className="flex gap-x-2">
                <div className="w-[200px]">
                    <p className="text-xl font-semibold">Domicilio</p>
                </div>

                <div>

                    <div className="flex gap-x-4 mb-2">

                        <div>
                            <InputCreateEmpresaForm
                                height="h-[35px]"
                                width="w-[300px]"
                                label="Calle"
                                register={register("direccion.calle", {
                                    required: "La calle es requerida",
                                    maxLength: 50
                                })}/>
                            <div className="h-[20px]">
                                {errors.direccion?.calle?.type === "required" && (
                                    <p className="valErrorText text-sm">{errors.direccion.calle.message}</p>
                                )}
                                {errors.direccion?.calle?.type === "maxLength" && (
                                    <p className="valErrorText text-sm">Número máximo de caracteres es 50</p>
                                )}
                            </div>
                        </div>

                        <div>
                            <InputCreateEmpresaForm 
                                height="h-[35px]"
                                width="w-[300px]"
                                label="Colonia"
                                register={register("direccion.colonia", {
                                    required: "La colonia es requerida",
                                    maxLength: 50
                                })}/>
                            <div className="h-[20px]">
                                {errors.direccion?.colonia?.type === "required" && (
                                    <p className="valErrorText text-sm">{errors.direccion.colonia.message}</p>
                                )}
                                {errors.direccion?.colonia?.type === "maxLength" && (
                                    <p className="valErrorText text-sm">Número máximo de caracteres es 50</p>
                                )}
                            </div>
                        </div>

                        <div>
                            <InputCreateEmpresaForm 
                                height="h-[35px]"
                                width="w-[300px]"
                                label="Numero Exterior"
                                register={register("direccion.numeroExterior", {
                                    required: "El numero exterior es requerido",
                                    maxLength: 10
                                })}/>
                            <div className="h-[20px]">
                                {errors.direccion?.numeroExterior?.type === "required" && (
                                    <p className="valErrorText text-sm">{errors.direccion.numeroExterior.message}</p>
                                )}
                                {errors.direccion?.numeroExterior?.type === "maxLength" && (
                                    <p className="valErrorText text-sm">Número máximo de caracteres es 10</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-x-4 mt-2">
                        <div>
                            <InputCreateEmpresaForm 
                                height="h-[35px]"
                                width="w-[300px]"
                                label="Codigo Postal"
                                register={register("direccion.codigoPostal", {
                                    required: "El codigo postal es requerido",
                                    maxLength: 10
                                })}/>
                            <div className="h-[20px]">
                                {errors.direccion?.codigoPostal?.type === "required" && (
                                    <p className="valErrorText text-sm">{errors.direccion.codigoPostal.message}</p>
                                )}
                                {errors.direccion?.codigoPostal?.type === "maxLength" && (
                                    <p className="valErrorText text-sm">Número máximo de caracteres es 10</p>
                                )}
                            </div>
                        </div>

                        <div>
                            <SelectCreateEmpresaForm
                                height="h-[35px]"
                                width="w-[300px]"
                                label="Municipio"
                                register={register("direccion.municipioId", {
                                    required: "El municipio es requerido",
                                    min: 1,
                                })}
                                datos={selectValues.municipios.map((mun, index) => (
                                    <option key={index} value={mun.id}>{mun.nombre}</option>
                                ))}/>
                            <div className="h-[20px]">
                                {errors.direccion?.municipioId?.type === "required" && (
                                    <p className="valErrorText text-sm">{errors.direccion.municipioId.message}</p>
                                )}
                                {errors.direccion?.municipioId?.type === "min" && (
                                    <p className="valErrorText text-sm">El estado de la empresa es requerido</p>
                                )}
                            </div>
                        </div>

                        <div>
                            <InputCreateEmpresaForm 
                                height="h-[35px]"
                                width="w-[300px]"
                                label="Coordenadas"
                                register={register("direccion.coordenadas", {
                                    maxLength: 50
                                })}/>
                            <div className="h-[20px]">
                                {errors.direccion?.coordenadas?.type === "maxLength" && (
                                    <p className="valErrorText text-sm">Número máximo de caracteres es 50</p>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
    );
}